<template>
  <div id="app">
    <div id="layout">
      <!-- Menu toggle -->
      <a href="#menu" id="menuLink" class="menu-link">
        <!-- Hamburger icon -->
        <span></span>
      </a>
      <Sidebar />
      <div class="content" id="main">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from './components/Sidebar.vue'

export default {
  name: 'App',
  components: {
    Sidebar,
  },
  mounted: function() {

      var layout   = document.getElementById('layout'),
          menu     = document.getElementById('menu'),
          menuLink = document.getElementById('menuLink'),
          content  = document.getElementById('main');
      console.warn('menuLink', menuLink, 'menu', menu, 'layout', layout, 'content', content)

      function toggleClass(element, className) {
          var classes = element.className.split(/\s+/),
              length = classes.length,
              i = 0;

          for(; i < length; i++) {
            if (classes[i] === className) {
              classes.splice(i, 1);
              break;
            }
          }
          // The className is not found
          if (length === classes.length) {
              classes.push(className);
          }

          element.className = classes.join(' ');
      }

      function toggleAll(e) {
          var active = 'active';

          e.preventDefault();
          toggleClass(layout, active);
          toggleClass(menu, active);
          toggleClass(menuLink, active);
      }

      menuLink.onclick = function (e) {
          toggleAll(e);
      };

      content.onclick = function(e) {
          if (menu.className.indexOf('active') !== -1) {
              toggleAll(e);
          }
      };
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}


</style>
